import {
    Modifier,
    EditorState,
    SelectionState,
} from 'draft-js';

export const insertText = (editorState, textToInsert) => {
    const currentContent = editorState.getCurrentContent();
    const currentSelection = editorState.getSelection();
    const textWithSpace = `${textToInsert} `;

    const newContent = Modifier.replaceText(
        currentContent,
        currentSelection,
        textWithSpace,
    );

    return EditorState.push(editorState, newContent, 'insert-characters');
};
export const insertLink = (editorState, href, textToInsert) => {
    const currentContent = editorState.getCurrentContent();
    const currentSelection = editorState.getSelection();

    const newContent = Modifier.replaceText(
        currentContent,
        currentSelection,
        textToInsert,
    );

    const newContentWithEntity = newContent.createEntity(
        'LINK',
        'MUTABLE',
        { url: href },
    );

    const entityKey = newContentWithEntity.getLastCreatedEntityKey();

    const anchorOffset = currentSelection.getAnchorOffset();
    const newSelection = new SelectionState({
        anchorKey: currentSelection.getAnchorKey(),
        anchorOffset,
        focusKey: currentSelection.getAnchorKey(),
        focusOffset: anchorOffset + textToInsert.length,
    });

    const newContentWithLink = Modifier.applyEntity(
        newContentWithEntity,
        newSelection,
        entityKey,
    );

    const withLinkText = EditorState.push(
        editorState,
        newContentWithLink,
        'insert-characters',
    );

    return EditorState.forceSelection(
        withLinkText,
        newContent.getSelectionAfter(),
    );
};

export const replaceText = (editorState, anchorKey, startIndex, endIndex, textToInsert) => {
    const currentContent = editorState.getCurrentContent();

    let rangeToRemove = SelectionState.createEmpty(anchorKey);
    rangeToRemove = rangeToRemove.merge({
        anchorOffset: startIndex,
        focusOffset: endIndex,
    });

    const updatedContentState = Modifier.removeRange(
        currentContent,
        rangeToRemove,
        'backward',
    );
    const editorStateWithRemovedPart = EditorState.push(editorState, updatedContentState, 'remove-range');

    let selectionToFocus = SelectionState.createEmpty(anchorKey);
    selectionToFocus = selectionToFocus.merge({
        anchorOffset: startIndex,
        focusOffset: startIndex,
    });

    const newContent = Modifier.replaceText(
        updatedContentState,
        selectionToFocus,
        textToInsert,
    );

    return EditorState.push(editorStateWithRemovedPart, newContent, 'insert-characters');
};

export const removeText = (editorState, anchorKey, startIndex, endIndex) => {
    const currentContent = editorState.getCurrentContent();

    let rangeToRemove = SelectionState.createEmpty(anchorKey);
    rangeToRemove = rangeToRemove.merge({
        anchorOffset: startIndex,
        focusOffset: endIndex,
    });

    const updatedContentState = Modifier.removeRange(
        currentContent,
        rangeToRemove,
        'backward',
    );

    const updatedEditorState = EditorState.push(editorState, updatedContentState, 'remove-range');

    return setCursorAt(updatedEditorState, anchorKey, startIndex);
};

export const setCursorAt = (editorState, key, cursorIndex) => {
    const selection = new SelectionState({
        anchorKey: key,
        anchorOffset: cursorIndex,
        focusKey: key,
        focusOffset: cursorIndex,
    });
    return EditorState.forceSelection(editorState, selection);
};

export const getCursorPositionData = (editorState) => {
    const contentState = editorState.getCurrentContent();
    const selectionState = editorState.getSelection();
    const anchorKey = selectionState.getAnchorKey();
    const currentContentBlock = contentState.getBlockForKey(anchorKey);
    const start = selectionState.getStartOffset();
    const currentContentBlockText = currentContentBlock.getText();

    return {
        start,
        anchorKey,
        text: currentContentBlockText,
    };
};
